import { defaultUIAccessLevels, generateKeyNamesByAccessLevel } from '@nu-art/permissions-shared';
export const Domain_Search = Object.freeze({
    _id: '9365aa05bfbfa2013a3648ee7659afef',
    namespace: 'Search',
});
export const searchPermissionKeys = generateKeyNamesByAccessLevel(Domain_Search.namespace, defaultUIAccessLevels);
//# sourceMappingURL=search.js.map